module.exports = __webpack_public_path__ + "static/media/pdf_excel.9daf5843.png";